<template>
  <v-line-chart
    :chart-data="data"
    :chart-options="options"
    :plugins="plugins"
  />
</template>

<script>
import Chart from 'chart.js/auto';
import {Line} from "vue-chartjs/legacy";

export default {
  name: 'LineChart',
  components: {
    VLineChart: Line
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    options: {
      type: Object,
      default: () => {}
    },
    plugins: {
      type: Array,
      default: () => []
    }
  }
}
</script>